import React, { useState } from 'react';
import { CourseHeader } from './components/CourseHeader';
import { TabNavigation, TabId } from './components/TabNavigation';
import { CourseIntroductionTab } from './components/CourseIntroductionTab';
export function App() {
  const [activeTab, setActiveTab] = useState<TabId>('introduction');
  return <div className="min-h-screen bg-[#f9fafb] text-gray-900 font-sans" data-id="element-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-1">
        <CourseHeader data-id="element-2" />

        <TabNavigation activeTab={activeTab} onTabChange={setActiveTab} data-id="element-3" />

        <main data-id="element-4">
          {activeTab === 'introduction' ? <CourseIntroductionTab data-id="element-5" /> : <div className="bg-white border border-gray-200 rounded-lg p-12 text-center" data-id="element-6">
              <p className="text-gray-500" data-id="element-7">
                Content for{' '}
                <span className="font-semibold text-gray-900" data-id="element-8">{activeTab}</span>{' '}
                tab is not implemented in this demo.
              </p>
              <button onClick={() => setActiveTab('introduction')} className="mt-4 text-indigo-600 hover:text-indigo-700 text-sm font-medium" data-id="element-9">
                Go to Course Introduction Tab
              </button>
            </div>}
        </main>
      </div>
    </div>;
}